/* eslint-disable camelcase */
import { WorkshopOpeningHour } from '../../models';
import { GET_WORKSHOP_OPENING_HOURS } from '../constants/workshopOpeningHours';

export const getWorkshopOpeningHours = (data) => {
  const { id, workshop_opening_hours } = data;
  /* eslint-disable no-param-reassign */
  const workWeek = workshop_opening_hours.reduce((result, entry) => {
    if (!result[entry.day_of_week]) {
      result[entry.day_of_week] = [];
    }
    result[entry.day_of_week].push(
      new WorkshopOpeningHour(
        entry.id,
        entry.day_of_week,
        entry.opens_at && entry.opens_at.substring(0, 5),
        entry.closes_at && entry.closes_at.substring(0, 5),
        entry.closed,
        entry.opened_24h,
        entry.workshop_typ,
      ),
    );
    return result;
  }, {});
  /* eslint-enable no-param-reassign */

  return (dispatch) => {
    dispatch({
      type: GET_WORKSHOP_OPENING_HOURS,
      workshopOwnershipId: id,
      monday: workWeek[0],
      tuesday: workWeek[1],
      wednesday: workWeek[2],
      thursday: workWeek[3],
      friday: workWeek[4],
      saturday: workWeek[5],
      sunday: workWeek[6],
    });
  };
};

export const getWorkshopOpeningHoursForEdit = (workshop_opening_hours) => {
  /* eslint-disable no-param-reassign */
  const workWeek = workshop_opening_hours.reduce((result, entry) => {
    if (!result[entry.day_of_week]) {
      result[entry.day_of_week] = [];
    }
    result[entry.day_of_week].push(
      new WorkshopOpeningHour(
        entry.id,
        entry.day_of_week,
        entry.opens_at && entry.opens_at.substring(0, 5),
        entry.closes_at && entry.closes_at.substring(0, 5),
        entry.closed,
        entry.opened_24h,
        entry.workshop_typ,
      ),
    );
    return result;
  }, {});
  /* eslint-enable no-param-reassign */

  return (dispatch) => {
    dispatch({
      type: GET_WORKSHOP_OPENING_HOURS,
      monday: workWeek[0],
      tuesday: workWeek[1],
      wednesday: workWeek[2],
      thursday: workWeek[3],
      friday: workWeek[4],
      saturday: workWeek[5],
      sunday: workWeek[6],
    });
  };
};
